const LIST_SOURCE_LERE_PREFIX = 'LERE'
export const LIST_SOURCE_LERE_UNKNOWN_MODEL = 'unknown'

export const getLereListSource = (source: string | undefined) => {
  return source ? [
    LIST_SOURCE_LERE_PREFIX,
    source,
  ].join(' - ') : [
    LIST_SOURCE_LERE_PREFIX,
    LIST_SOURCE_LERE_UNKNOWN_MODEL,
  ].join(' - ')
}
